import { render, staticRenderFns } from "./SharerRateDetails.vue?vue&type=template&id=2e895914&scoped=true"
import script from "./SharerRateDetails.vue?vue&type=script&lang=js"
export * from "./SharerRateDetails.vue?vue&type=script&lang=js"
import style0 from "./SharerRateDetails.vue?vue&type=style&index=0&id=2e895914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e895914",
  null
  
)

export default component.exports